__webpack_require__.p = "https://static.parastorage.com/services/restaurant-menus-showcase-ooi/a973b9808db9c3b9262f396c095d6fbfdf9c805f352fdef0619696a5/";